export default __webpack_public_path__ + "static/media/apilador.240e278d.png";